import { gql } from '@apollo/client'

const ALL_AGENCIES = gql`
  query AgenciesQuery {
    agencies_LAS (limit:2000)  {
      id
      name
      securityKey
    }
  }
`

export { ALL_AGENCIES }
